/**
 * Wraps a DI service accessor so the underlying service is resolved on first
 * property access instead of at module-evaluation time.
 *
 * Use this when a module-level singleton must receive a service that reads from
 * the DI container (e.g. {@link getConfigService}), which throws with
 * `IllegalStateError` when accessed before the application container is loaded.
 */
export function lazyService<T extends object>(resolve: () => T): T {
    let instance: T | undefined;
    return new Proxy({} as T, {
        get(_target, property) {
            instance ??= resolve();
            const value = Reflect.get(instance as object, property, instance);
            return typeof value === "function" ? value.bind(instance) : value;
        },
    });
}
